<span class="badge badge-center rounded-pill bg-success pointer" (click)="openModal()">{{cellValue?.data?.destination_address?.length}}</span>